import { getStrapiURL } from "./api-helpers";

type searchParam = "articles" | "faqs" | "pages" | "all";

const search = async (
  query: string,
  param: searchParam,
  page: number,
  pageSize: number = 1
) => {
  const token = process.env.NEXT_PUBLIC_STRAPI_API_TOKEN;

  const path = getStrapiURL(
      `/api/fuzzy-search/search?query=${query}&locale=ro&populate[articles]=*&pagination[articles][pageSize]=${pageSize}&pagination[articles][page]=${page}&populate[faqs]=*&pagination[faqs][pageSize]=${pageSize}&pagination[faqs][page]=${page}&populate[pages]=*&pagination[pages][pageSize]=${pageSize}&pagination[pages][page]=${page}&filters[contentTypes]=${
          param === "all" ? "articles,faqs,pages" : param
      }&filters[articles][publishedAt][$notNull]=true&filters[faqs][publishedAt][$notNull]=true&filters[pages][publishedAt][$notNull]=true`
  )

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  return await fetch(path, options);
};

export default search;
